"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var category_utils_1 = require("@shared/utils/category-utils");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
// @ts-ignore
function CategoryUtilsFactory(reportTypeService) {
    var reportType = reportTypeService.getReportType();
    var categoryUtils = new category_utils_1.CategoryUtils(reportType);
    var categoriesCacheMap = {};
    return {
        isCategoryField: isCategoryField,
        getCategoryFieldInfo: getCategoryFieldInfo,
        getCategories: getCategories
    };
    function isCategoryField(fieldId, fieldset) {
        var categoryFieldInfo = getCategoryFieldInfo(fieldId, fieldset);
        return !lodash_1.default.isEmpty(categoryFieldInfo);
    }
    function getCategoryFieldInfo(fieldId, fieldset) {
        var categories = getCategories(fieldset);
        return lodash_1.default.get(categories, fieldId);
    }
    function getCategories(fieldset) {
        var fieldsetId = lodash_1.default.get(fieldset, 'definition.fieldSetId');
        if (!categoriesCacheMap[fieldsetId]) {
            categoriesCacheMap[fieldsetId] = categoryUtils.getCategories(fieldset);
        }
        return categoriesCacheMap[fieldsetId];
    }
}
(function (module) {
    module.factory('pr.categoryUtils', [
        'pr.reportTypeService',
        CategoryUtilsFactory
    ]);
})(angular_1.module('qualtrics.pr'));
